import {
  AiIconSvg,
  BusinessSettingsIcon,
  CashIcon,
  StarIcon,
  announcementIcon,
  chatMessageIcon,
  overdueTaskIcon,
  reviewDocumentIcon,
  securityShieldIcon,
  userProfileIcon,
  vacationIcon,
  workingIcon,
} from '../icons/icon.constants';

/**
 * Maps icon names to their corresponding SVG icons
 * @param iconName - The name of the icon category
 * @returns The SVG string for the icon, or a default icon if not found
 */
export function getNotificationIcon(iconName: string): string {
  const iconMap: { [key: string]: string } = {
    communication: chatMessageIcon,
    message: chatMessageIcon,
    chat: chatMessageIcon,
    person: userProfileIcon,
    user: userProfileIcon,
    profile: userProfileIcon,
    feedback: reviewDocumentIcon,
    review: reviewDocumentIcon,
    campaign: announcementIcon,
    announcement: announcementIcon,
    calendar: workingIcon,
    payment: CashIcon,
    billing: CashIcon,
    star: StarIcon,
    rating: StarIcon,
    automation: AiIconSvg,
    ai: AiIconSvg,
    integration: BusinessSettingsIcon,
    business: BusinessSettingsIcon,
    security: securityShieldIcon,
    shield: securityShieldIcon,
    system: BusinessSettingsIcon,
    vacation: vacationIcon,
    working: workingIcon,
    overdue: overdueTaskIcon,
  };

  return iconMap[iconName.toLowerCase()] || chatMessageIcon;
}
